export default "__VITE_ASSET__B3x6CanM__"